/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLeads = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M9.6 12c.2-.5.4-1 .4-1.5C10 8.6 8.4 7 6.5 7S3 8.6 3 10.5c0 .5.1 1 .4 1.5H2l1.5 1.7C6 16.4 8.1 20 8.8 21.5l.4.5h6l.1-.8c.3-1.4 2.9-4.9 5.2-7.5L22 12zM5 10.5C5 9.7 5.7 9 6.5 9S8 9.7 8 10.5 7.3 12 6.5 12 5 11.3 5 10.5zm8.6 9.5h-3.2c-.8-1.4-2.2-3.8-3.9-6h11.2c-1.5 1.6-3.4 4.1-4.1 6z" />
      <path d="M18.5 11c1.9 0 3.5-1.6 3.5-3.5S20.4 4 18.5 4 15 5.6 15 7.5s1.6 3.5 3.5 3.5zm0-5c.8 0 1.5.7 1.5 1.5S19.3 9 18.5 9 17 8.3 17 7.5 17.7 6 18.5 6zm-7 2c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm0-4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z" />
    </g>
  </Icon>
);
export { SvgLeads as Leads };
